import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Box, Card, Column, Spacing } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './DeckStack.module.scss';
export const GetDeckStackTID = (parentTestId)=>getTestIds(parentTestId);
export const DeckStack = (param)=>{
    let { children, border, size = 'card', compact, settling, testId } = param;
    const { DeckStackTestIds } = useMemo(()=>GetDeckStackTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        className: cn(styles.deck, {
            [styles.compact]: compact
        }),
        testId: DeckStackTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(Card, {
                bi: {
                    name: 'pulse_opportunities_deck_far_back_card'
                },
                testId: DeckStackTestIds.BackCards.Far(),
                skin: "white",
                borderSkin: "default",
                borderRadius: "l",
                autoHeight: true,
                className: cn(styles.backCard, styles.farBackCard, {
                    [styles.settling]: settling
                }),
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsx(Card, {
                bi: {
                    name: 'pulse_opportunities_deck_near_back_card'
                },
                testId: DeckStackTestIds.BackCards.Near(),
                skin: "white",
                borderSkin: "default",
                borderRadius: "l",
                autoHeight: true,
                className: cn(styles.backCard, styles.nearBackCard, {
                    [styles.settling]: settling
                }),
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsx(Column, {
                gap: Spacing.Space12,
                padding: Spacing.Space20,
                className: cn(styles.front, styles[border], styles[size]),
                testId: DeckStackTestIds.Front(),
                children: children
            })
        ]
    });
};
